/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  LeverageGetAccruedInterestByUserOptions,
  LeverageGetAccruedInterestByUserResponses,
} from '../types/LeverageGetAccruedInterestByUser'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @summary Get current accrued leverage interest for a specific user
 * {@link /v1/leverage/accrued_interest/:user_id}
 */
export function leverageGetAccruedInterestByUser<ThrowOnError extends boolean = true>(
  options: Options<LeverageGetAccruedInterestByUserOptions, ThrowOnError>,
): Unwrappable<RequestResult<LeverageGetAccruedInterestByUserResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'GET',
      url: '/v1/leverage/accrued_interest/{user_id}',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<LeverageGetAccruedInterestByUserResponses, ThrowOnError>>,
  )
}
